import { ServiceReport } from "../../../serviceOrdering/interfaces/ServiceReport.ts";

export const DwellingStatsTable = ({ report }: { report: ServiceReport }) => {
  return (
    <table className={"table text-center"}>
      <thead className={"bg-primary"}>
        <tr>
          <th className={"border border-primary text-primary"}>Pièces</th>
          <th className={"border border-primary text-primary"}>
            Total unités de constat
          </th>
          <th className={"border border-primary text-primary"}>Neuf</th>
          <th className={"border border-primary text-primary"}>Bon état</th>
          <th className={"border border-primary text-primary"}>État moyen</th>
          <th className={"border border-primary text-primary"}>Dégradé</th>
          <th className={"border border-primary text-primary"}>HS</th>
          <th className={"border border-primary text-primary"}>Propreté</th>
        </tr>
      </thead>
      <tbody>
        {report?.rooms?.map((room, index) => {
          return (
            <tr key={index}>
              <td className={"border border-primary"}>{room.name}</td>
              <td className={"border border-primary"}>{room.nbUnits}</td>
              <td className={"border border-primary"}>
                {room.unitsCondition.new.number}(
                {room.unitsCondition.new.percentage}
                %)
              </td>
              <td className={"border border-primary"}>
                {room.unitsCondition.good.number}(
                {room.unitsCondition.good.percentage}%)
              </td>
              <td className={"border border-primary"}>
                {room.unitsCondition.average.number}(
                {room.unitsCondition.average.percentage}%)
              </td>
              <td className={"border border-primary"}>
                {room.unitsCondition.poor.number}(
                {room.unitsCondition.poor.percentage}%)
              </td>
              <td className={"border border-primary"}>
                {room.unitsCondition.oof.number}(
                {room.unitsCondition.oof.percentage}
                %)
              </td>
              <td className={"border border-primary"}>
                {room.unitsCleanliness.clean.percentage}%
              </td>
            </tr>
          );
        })}
        <tr>
          <td className={"border border-primary font-bold"}>TOTAL</td>
          <td className={"border border-primary"}>{report.totalUnits}</td>
          <td className={"border border-primary"}>
            {report.totalCondition.new.number}(
            {report.totalCondition.new.percentage}
            %)
          </td>
          <td className={"border border-primary"}>
            {report.totalCondition.good.number}(
            {report.totalCondition.good.percentage}%)
          </td>
          <td className={"border border-primary"}>
            {report.totalCondition.average.number}(
            {report.totalCondition.average.percentage}%)
          </td>
          <td className={"border border-primary"}>
            {report.totalCondition.poor.number}(
            {report.totalCondition.poor.percentage}%)
          </td>
          <td className={"border border-primary"}>
            {report.totalCondition.oof.number}(
            {report.totalCondition.oof.percentage}
            %)
          </td>
          <td className={"border border-primary"}></td>
        </tr>
      </tbody>
    </table>
  );
};
